import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CharField } from 'components/forms'
import styles from './_workoutForm.css'

export default function Steps () {
  return (
    <CharField
      bold
      short
      type='number'
      min='0'
      step='1'
      name='steps'
      inputContainerClassName={styles.shortInput}
      labelComponent={(
        <FormattedMessage
          id='workouts.create.steps'
          defaultMessage='Steps'
        />
      )}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/workouts/WorkoutForm/Steps.jsx